import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { FormattedNumber } from "react-intl";
import useCustomizationContext from "../../../../hooks/useCustomizationContext";
import { ReactComponent as IconMinusCircle } from "../../../../icons/minus-circle.svg";
import { ReactComponent as IconPlusCircle } from "../../../../icons/plus-circle.svg";
import { Panel } from "../../../../states/customization";
import { Content } from "../../../../types/customization/content";
import { maxPageReached } from "../../../../utils/customization/configuration";
import { findPageAndDefinition, findPrintQuantity } from "../../../../utils/customization/finders";
import { isEmptyPage } from "../../../../utils/customization/page";
import { getMaxPageReachedMessage } from "../../../../utils/customMessages";
import "./style.scss";

interface Props {
  content: Content;
  pageKey: string;
}

const PageQuantity: FunctionComponent<Props> = ({ content, pageKey }) => {
  const {
    dispatch,
    template,
    configuration,
    ui: { panel },
  } = useCustomizationContext();
  const { page } = findPageAndDefinition(pageKey, template, content);

  if (content.templateType !== "print" || (isEmptyPage(page) && content.pages.length === 1)) {
    return null;
  }

  const { quantity } = findPrintQuantity(pageKey, content);

  const maxPagesNotReached = !maxPageReached(content, configuration);
  const maxPagesMessage = getMaxPageReachedMessage(content.templateType, configuration);

  const onMinusClick = () => {
    if (
      quantity === 1 &&
      panel.key &&
      panel.key === pageKey &&
      (panel.current === Panel.EDITPAGE || panel.current === Panel.PAGEOPTIONS)
    ) {
      dispatch({
        type: "setPanel",
        panel: Panel.CLOSED,
      });
    }
    dispatch({ type: "changePrintQuantity", pageKey, quantity: -1 });
  };
  const onPlusClick = () =>
    maxPagesNotReached
      ? dispatch({ type: "changePrintQuantity", pageKey, quantity: 1 })
      : dispatch({
          code: "KFE-003",
          customMessage: maxPagesMessage,
          type: "addNotificationByCode",
        });

  return (
    <div className="PageQuantity">
      <div className="PageQuantity-action" onClick={onMinusClick}>
        <IconMinusCircle />
      </div>
      <div className="PageQuantity-content">
        <FormattedNumber value={quantity} />
      </div>
      <div
        className={classNames("PageQuantity-action", {
          "PageQuantity-action--disabled": !maxPagesNotReached,
        })}
        onClick={onPlusClick}
      >
        <IconPlusCircle />
      </div>
    </div>
  );
};

export default PageQuantity;
